export default "__VITE_ASSET__BhJk_VMD__"